import { TextSelection, NodeSelection, AllSelection, } from 'prosemirror-state';
export const wrapLines = (nodeType, attrs = {}, joiner = '\n') => (state, dispatch) => {
    const { selection, tr } = state;
    let canApply = false;
    if (selection.ranges.length > 1) {
        selection.ranges.forEach((_, index) => {
            const { $from, $to } = tr.selection.ranges[index];
            const newNode = createNodeWrappingLines(nodeType, attrs, tr.doc, $from.pos, $to.pos, joiner);
            const bRange = $from.blockRange($to);
            if (bRange) {
                canApply = true;
                tr.replaceWith(bRange.start, bRange.end, newNode);
            }
        });
    }
    else {
        const newNode = createNodeWrappingLines(nodeType, attrs, tr.doc, selection.from, selection.to, joiner);
        const { $from, $to } = selection;
        let range = { start: 0, end: 0 };
        if (selection instanceof NodeSelection ||
            selection instanceof AllSelection) {
            const bRange = $from.blockRange($to);
            if (bRange) {
                canApply = true;
                range = bRange;
            }
        }
        else {
            canApply = true;
            range = { start: $from.before(), end: $to.after() };
        }
        tr.replaceWith(range.start, range.end, newNode);
        tr.setSelection(TextSelection.between(tr.doc.resolve(selection.from), tr.doc.resolve(selection.to - (range.end - range.start - newNode.nodeSize))));
    }
    if (!canApply) {
        return false;
    }
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr.scrollIntoView());
    return true;
};
function createNodeWrappingLines(nodeType, attrs, doc, from, to, joiner) {
    const textOfLines = [];
    doc.nodesBetween(from, to, (node) => {
        if (node.isTextblock) {
            let text = node.textContent;
            node.forEach((child, offset) => {
                if (!child.isText && offset < node.nodeSize) {
                    const childHolderText = child.type.name === 'hard_break' ? '\n' : ' ';
                    text = `${text.slice(0, offset)}${childHolderText}${text.slice(offset)}`;
                }
            });
            textOfLines.push(text);
            return false;
        }
        if (node.isLeaf) {
            textOfLines.push('');
            return false;
        }
        return undefined;
    });
    const joinedText = textOfLines.join(joiner);
    return nodeType.create(attrs, joinedText ? doc.type.schema.text(joinedText) : undefined);
}
//# sourceMappingURL=wrapLines.js.map